import React from "react";
import Navbars from "../Components/navbar";
import Project from "./project";
import Timeline from "./timeline";
import Footer from "../Components/Footer";






const Timelinelink = () => {
    return(
        <>
        <Navbars />
        <Timeline />
        <Footer />
        </>
    )
}

export default Timelinelink;